import { render } from "./uiCheckbox.vue?vue&type=template&id=1ace8b60&scoped=true"
import script from "./uiCheckbox.vue?vue&type=script&lang=js"
export * from "./uiCheckbox.vue?vue&type=script&lang=js"

import "./uiCheckbox.vue?vue&type=style&index=0&id=1ace8b60&scoped=true&lang=css"

import exportComponent from "/home/runner/work/bot-v2/bot-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ace8b60"]])

export default __exports__